app.controller("SearchWatcherExtendController",
	["$scope", "$http", "$timeout", function($scope, $http, $timeout) {
		$scope.title = '24h Etumatkan jatkaminen';
		$scope.Extend = function(searchWatcherId) {
			$http({
				method: "POST",
				url: "/api/km/KMSite/extendSearchWatch",
				data: {
					id: searchWatcherId
				}
			})
			.then(function (data) {
				$scope.title = '24h Etumatkaasi on nyt jatkettu';
				$scope.text = 'Saat jatkossa 24h etumatkan viestejä kuten ennenkin.';
			},
			function (data) {
				$scope.title = '24h Etumatkan jatkaminen epäonnistui';
				$scope.text = '24h Etumatkasi oli mahdollisesti jo vanhentunut. Voit luoda tilalle kokonaan uuden 24h Etumatkan.';
			});
		};
	}]
);